import sticky from 'jquery-sticky';

(function($) {
  "use strict";
  $(document).ready(function() {
    var $languageSelector = $('.language-selector'),
        $languageOption = $('.language-selector .option.selected'),
        $header = $('header'),
        $menuOpen = $('#open-menu'),
        $menuClose = $('#close-menu'),
        $moreButton = $('#menu-toggle a'),
        $body = $('body'),
        $moreButtonMobile = $('#menu-toggle-mobile a'),
        $footerForm = $('footer #formsubscribe'),
        $moreMenuMobile = $('.responsive-menu--more'),
        $footerShowFormButton = $('#show-formsubscribe'),
        $footerHideFormButton = $('#hide-formsubscribe'),
        $formSubscribeButton = $('#formsubscribe .button'),
        $helloBar = $('#hello-bar');

    /*  [ Main Menu ]
        - - - - - - - - - - - - - - - - - - - - */
    $('.sub-menu').each(function() {
      $(this).parent().addClass('has-child').find('> a').append('<span class="arrow"><i class="fa fa-angle-right"></i></span>');
    });
    $('.main-menu .arrow, .sidebar .widget ul.menu .arrow').on('click', function(e) {
      e.preventDefault();
      $(this).parent().parent().toggleClass('open').find('> .sub-menu').slideToggle();
    });
    $('.mobile-btn').on('click', function() {
      $(this).parents('.main-menu').toggleClass('open');
      $('body').toggleClass('menu-open');
    });

    $('html').on('click', function(e) {
      if ($(e.target).closest('.main-menu.open').length == 0) {
        $('.main-menu').removeClass('open');
        $('body').removeClass('menu-open');
      }
    });

    /*Add same value to attr ID of checkbox and attr FOR of label ( add it dinamically)*/
    $(".comment-form .checkbox").each(function(val, key) {
      $(this).find('input[type=checkbox]').attr('id','checkbox-form-'+val);
      $(this).find('label').attr('for','checkbox-form-'+val);
    });

    /*  [ Accordion ]
    - - - - - - - - - - - - - - - - - - - - */
    $('.accordion.first-open > li:first-child').addClass('open');
    $('.accordion-title a').on('click', function(event) {
      event.preventDefault();
      if ($(this).parents('li').hasClass('open')) {
        $(this).parents('li').removeClass('open').find('.accordion-content').slideUp(400);
      } else {
        $(this).parents('.accordion').find('.accordion-content').not($(this).parents('li').find('.accordion-content')).slideUp(400);
        $(this).parents('.accordion').find('> li').not($(this).parents('li')).removeClass('open');
        $(this).parents('li').addClass('open').find('.accordion-content').slideDown(400);
      }
    });

    /*  [ ZohoChat ]
    - - - - - - - - - - - - - - - - - - - - */
    if($("#titleDiv").length>0){
      setTimeout(function() {
        document.getElementById('titlediv').style.visibility = "hidden";
      }, 6000);
    }



    /*  [ Sticky Header ]
     - - - - - - - - - - - - - - - - - - - - */
    if ($('body.admin-bar').length > 0 && $(window).width() > 600) {
      var wpadminbar = $('#wpadminbar').outerHeight();
      $('.header-sticky .site-header').sticky({
        topSpacing: wpadminbar
      });
    } else {
      $('.header-sticky .site-header').sticky({
        topSpacing: 0
      });
    }

    /*  [ Has VC in Body class ]
     - - - - - - - - - - - - - - - - - - - - */
    if ($('.entry-content .vc_row').length == 0) {
      $('body').addClass('not-vc');
    }

    /*  [ Testimonials Slider ]
     - - - - - - - - - - - - - - - - - - - - */
    var owlRtl = $('body').hasClass('rtl') ? true : false;
    $('.testimonials').each(function(index, el) {
      var item = $(this).attr('data-item');
      var animatedin = $(this).attr('data-animatedin');
      var animatedout = $(this).attr('data-animatedout');
      var owlPreview = $(this).find('.testi-preview .owl-carousel');
      owlPreview.owlCarousel({
        nav: false,
        dots: true,
        items: 1,
        rtl: owlRtl,
        responsive: {
          0: {
            items: 1
          }
        },
        animateIn: animatedin,
        animateOut: animatedout
      });
    });
    /*  [ Dropdown language Selector ]
     - - - - - - - - - - - - - - - - - - - - */
     $(window).on('click', function() {
       if ($languageSelector.has(event.target).length == 0 && !$languageSelector.is(event.target)) {
         $languageOption.removeClass('open');
       }
     });

    $languageOption.on('click', function() {
      $languageOption.toggleClass('open');
    });

    /*  [ Menu Mobile]
     - - - - - - - - - - - - - - - - - - - - */
    $menuOpen.on('click', function() {
      $header.addClass('open');
      return false;
    });

    $menuClose.on('click', function() {
      $header.removeClass('open');
      return false;
    });

    $moreButtonMobile.on('click', function() {
      $(this).toggleClass('open');
      $moreMenuMobile.toggleClass('open');

    });

    /*  [ More button]
     - - - - - - - - - - - - - - - - - - - - */
    $moreButton.on('click', function() {
      $moreButton.toggleClass('open');
      $body.toggleClass('collapse');
    });

    /*  [ Twitter Slider ]
    - - - - - - - - - - - - - - - - - - - - */
    $('.twitter-slider .owl-carousel').owlCarousel({
      nav: false,
      dots: true,
      items: 1,
      rtl: owlRtl,
      autoplay: true,
      responsive: {
        0: {
          items: 1
        }
      }
    });

    /*  [ Remove label when focus input login and register form ]
     - - - - - - - - - - - - - - - - - - - - */
    $('.wp-form .login-password input, .wp-form .login-username input, .wp-form .login-email input').change(function() {
      if ($(this).val().length < 1) {
        $(this).parent().find('label').fadeIn(100);
      } else {
        $(this).parent().find('label').fadeOut(100);
      }
    });
    $('.wp-form .login-password input, .wp-form .login-username input, .wp-form .login-email input').focus(function(event) {
      $(this).parent().find('label').fadeOut(100);
    });
    $('.wp-form .login-password input, .wp-form .login-username input, .wp-form .login-email input').blur(function(event) {
      if ($(this).val().length < 1) {
        $(this).parent().find('label').fadeIn(100);
      }
    });

    /*  [ Blog Slider ]
     - - - - - - - - - - - - - - - - - - - - */
    $('.blog-slider').each(function(index, el) {
      var item = $(this).attr('data-item');
      var auto = $(this).attr('data-auto');
      var autotime = $(this).attr('data-autotime');
      var dots = $(this).attr('data-dots');
      if (dots == 'true') {
        dots = true;
      } else {
        dots = false;
      };
      if (auto == 'true') {
        auto = true;
      } else {
        auto = false;
      };
      var owlRtl = $('body').hasClass('rtl') ? true : false;

      $(this).owlCarousel({
        nav: false,
        dots: dots,
        items: item,
        margin: 30,
        slideBy: item,
        autoplay: auto,
        rtl: owlRtl,
        autoplayTimeout: autotime,
        responsive: {
          0: {
            items: 1
          },
          541: {
            items: 2
          },
          768: {
            items: 2
          },
          990: {
            items: item
          }
        }
      });
    });

    /*  [ Services Slider ]
     - - - - - - - - - - - - - - - - - - - - */
    $('.services-slider').each(function(index, el) {
      var item = $(this).attr('data-item');
      var auto = $(this).attr('data-auto');
      var autotime = $(this).attr('data-autotime');
      var dots = $(this).attr('data-dots');
      var owlRtl = $('body').hasClass('rtl') ? true : false;
      if (dots == 'true') {
        dots = true;
      } else {
        dots = false;
      };
      if (auto == 'true') {
        auto = true;
      } else {
        auto = false;
      };

      $(this).find('.owl-carousel').owlCarousel({
        nav: false,
        dots: dots,
        items: item,
        slideBy: item,
        margin: 20,
        rtl: owlRtl,
        autoplay: auto,
        autoplayTimeout: autotime,
        responsive: {
          0: {
            items: 1
          },
          541: {
            items: 2
          },
          980: {
            items: 3
          },
          1200: {
            items: item
          }
        }
      });
    });

    /*  [ Counter Up ]
     - - - - - - - - - - - - - - - - - - - - */
    $('.counter-number').counterUp({
      delay: 10,
    });

    /*  [ Scroll to Div ]
     - - - - - - - - - - - - - - - - - - - - */
    $('.scroll a').on('click', function(event) {
      event.preventDefault();
      var id = $(this).attr('href');
      $('html,body').animate({
        scrollTop: $(id).offset().top
      }, 700);
    });

    /*  [ Live Search ]
     - - - - - - - - - - - - - - - - - - - - */
    /*    $('.page-title .page-title-search input[type=search]').each(function() {
          var _this = $(this);

          $(_this).on('focus', function() {
            $(this).parents('.header-search-form').find('.header-search-filter').addClass('show').parents('.header-search-form').addClass('open');
          });

          $(_this).keyup(function(event) {
            /* Act on the event */
    /*if ($(_this).val().length > 2) {
          $(_this).parent().addClass('loading');

        } else {
          $(_this).parent().removeClass('loading');
        }
      });

      var type = '';

      $(this).parents('.header-search-form').find('.search-filter input').on('click', function() {

        if ($(_this).val().length > 2) {
          $(_this).parent().addClass('loading');

        } else {
          $(_this).parent().removeClass('loading');
        }

        if ($(this).parent().hasClass('search-filter-all')) {
          type = ['any'];
          $(this).parents('.header-search-filter').find('input').not(this).attr('checked', false);

        } else {
          $(this).parents('.header-search-filter').find('.search-filter-all input').attr('checked', false);
          type = [];
          $(this).parents('.header-search-filter').find('input:checked').each(function(index, el) {
            type.push($(this).val());
          });
        }

        $(_this).keydown();
      });

      type = [];
      $(this).parents('.header-search-form').find('.search-filter input:checked').each(function(index, el) {
        type.push($(this).val());
      });

      $(_this).autocomplete({
          source: function(request, response) {
            $.ajax({
              url: ajaxurl,
              type: 'GET',
              cache: false,
              dataType: "json",
              data: {
                key: $(_this).val(),
                type: type,
                'ihelper_search_value': true
              },
              success: function(data) {
                response(data);
                $(_this).parent().removeClass('loading');
              }
            });
          },
          minLength: 3,
          select: function(event, ui) {
            $(_this).parent().attr('action', ui.item.link);
            $(_this).parent().find('input[type=search]').removeAttr('name');
            $(_this).parent().find('input[type=submit]').click();
          },
          open: function() {
            $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
          },
          close: function() {
            $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
          },
        })
        .autocomplete("instance")._renderItem = function(ul, item) {
          return $("<li>")
            .append("<div><a href='" + item.link + "'><span>" + item.label + "</span>" + item.desc + "</a></div>")
            .appendTo(ul);
        };

      $('.ui-autocomplete').appendTo($(_this).parents('.header-search-form'));
    });*/

    $('html').on('click', function(e) {
      if ($(e.target).closest('.header-search-form.open').length == 0) {
        $('.header-search-form').removeClass('open');
        $('.header-search-form .header-search-filter').removeClass('show');
      }
    });

    // Input empty on submit
    $('.page-title-search').on('submit', function(e) {
      if( $('.input-search').val().length === 0 ) {
        e.preventDefault();
        $('.header-search-form').addClass('error_empty');
        return;
      }
    });
    $('.page-title-search .input-search').on('click', function(e) {
      if( $('.header-search-form').hasClass( "error_empty" ) ) {
        $('.header-search-form').removeClass( "error_empty" );
      }
    });
    // Input empty on submit

    /*  [ Back to top ]
    - - - - - - - - - - - - - - - - - - - - */
    $('.back-to-top').on('click', function(e) {
      e.preventDefault();
      $("html, body").animate({
        scrollTop: 0
      }, 700);
    });

    $(window).load(function() {
      /*  [ Support rtl in Visual Composer ]
      - - - - - - - - - - - - - - - - - - - - */
      if ($('html').attr('dir') == 'rtl') {
        $('[data-vc-full-width="true"]').each(function(i, v) {
          var v = $(this).css('left');
          $(this).css('left', 'auto').css('right', v);
        });
      }

      /*  [ Page loader ]
      - - - - - - - - - - - - - - - - - - - - */
      $('body').addClass('loaded');
      setTimeout(function() {
        $('#page-loader').fadeOut();
      }, 500);
    });

    /*  [ Footer form ]
    - - - - - - - - - - - - - - - - - - - - */
    $('#bottom-2 #email-input').on('input', function() {
      var holder = $('#bottom-2 #email-label');
      holder.toggleClass('active', this.value != "");
    });

    // Open form subscription
    $footerShowFormButton.on('click', function(e) {
      e.preventDefault();
      $footerForm.css('display', 'flex').find('input[type=email]').focus();
      $('html, body').animate({
        scrollTop: $footerForm.offset().top
      }, 100);
    });

    // Close form subscription
    $footerHideFormButton.on('click', function(e) {
      e.preventDefault();
      $footerForm.hide();
    });

    // validation fields in form
    function validateField(field) {
      var emailRegex = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i),
        urlRegex = new RegExp(/(^|\s)((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi),
        numberRegex = new RegExp('^[0-9]+$'),
        val = field.val(),
        lang = document.documentElement.lang.substring(0,2),
        messageRequired_es = '¡Ouch! El campo es requerido.',
        messageRequired_en = '¡Ouch! This fiels is required',
        messageEmail_es = '¡Ouch! Ingresa un Email válido.',
        messageEmail_en = 'Ouch! Enter a valid Email',
        messageURL_es = '¡Ouch! Ingresa una URL válida.',
        messageURL_en = 'Ouch! Enter a valid URL',
        messageNumber_es = '¡Ouch! Ingresa un número válido.',
        messageNumber_en = 'Ouch! Enter a valid number',
        $parent = field.closest('.holder');

      if (!val && field.hasClass('required')) {
        $parent.addClass('error');

        if (lang == 'en') {
          $parent.attr('data-error', messageRequired_en );
        } else if (lang == 'es'){
          $parent.attr('data-error', messageRequired_es );
        }
      } else if (field.hasClass("check") && field.hasClass("required") && !field.is(':checked')) {
        $parent.addClass('error');

        if (lang == 'en') {
          $parent.attr('data-error', messageRequired_en );
        } else if (lang == 'es'){
          $parent.attr('data-error', messageRequired_es );
        }
      } else if (field.hasClass("email") && !val.match(emailRegex)) {
        $parent.addClass('error');

        if (lang == 'en') {
          $parent.attr('data-error', messageEmail_en );
        } else if (lang == 'es'){
          $parent.attr('data-error', messageEmail_es );
        }
      } else if (field.hasClass("url") && !val.match(urlRegex)) {
        $parent.addClass('error');

        if (lang == 'en') {
          $parent.attr('data-error', messageURL_en );
        } else if (lang == 'es'){
          $parent.attr('data-error', messageURL_es );
        }
      } else if (field.hasClass("number") && !val.match(numberRegex)) {
        $parent.addClass('error');

        if (lang == 'en') {
          $parent.attr('data-error', messageNumber_en );
        } else if (lang == 'es'){
          $parent.attr('data-error', messageNumber_es );
        }
      } else if (!field.is(":hidden") && (!field.hasClass("phone-number"))) {
        $parent.removeClass('error');
      }
    }

    function validateForm(form) {
      $('input', form).each(function() {
        validateField($(this));
      });

      return form.find('.error').length === 0 ? true : false;
    }

    function clearForm(form) {
      $('input:not(.button), textarea', form).val('');
      form.find('input:checkbox').removeAttr('checked');
    }

    $formSubscribeButton.on('click', function(event) {
      event.preventDefault();
        var $form = $(this).closest('form'),
        email = $form.find('input[type=email]'),
        aceptoPoliticas = $form.find('input[name=acepto_politicas]').is(':checked'),
        aceptoPromociones = $form.find('input[name=acepto_promociones]').is(':checked');

      if (validateForm($form)) {
        //accept Submit
        $form.addClass('disabled');
        var data = {
          email: email.val(),
          acepto_politicas: aceptoPoliticas,
          acepto_promociones: aceptoPromociones
        };
        sentDataBackend(data, "subscriber", "footer", $form)
        if(typeof OnetrustActiveGroups != 'undefined' && OnetrustActiveGroups.includes("C0003")) { // Functional Cookies
          setCookie('esubscriber', email.val(), 100000);
        }
        
        setTimeout(function(){
          $form[0].reset();
          $footerForm.hide();
        },8000);
      }
      return false;
    });

    function sentDataBackend(data, action, from_form, $form) {
     jQuery.ajax({
       type: 'POST',
       url: window.location.origin + "/wp-admin/admin-ajax.php",
       data: {
         data: data,
         from_form: from_form,
         action: "add_suscriber"
       },
       success: function(response) {

         if (action == "subscriber" || action == "full") {

           $form.removeClass('disabled');

           $form.addClass('success');
           setTimeout(function() {
               $form.removeClass('success');
           }, 8000);
         }
       }
     })
    }

    $('.post-ratings').on('click', function(){
      setTimeout(function(){
        if(typeof OnetrustActiveGroups != 'undefined' && !OnetrustActiveGroups.includes("C0003")) { // If Functional Cookies are not allowed
          deleteCookie('rated_');
        }    
      }, 1000);    
    });

    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60));
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
 

    var deleteCookie = function(name) {
       var ca = document.cookie.split(';');
    
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
    
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(name) == 0) { 
           document.cookie = c +';expires=Thu, 01 Jan 1970 00:00:01 GMT' + ";path=/";
        }
      }
    };

    setTimeout(function(){
      if ($header.hasClass("active-hb")) {
        $header.addClass("height-hello-bar");
        $helloBar.slideDown().css("display", "flex");
      }
    });
    // Function to show Hello Bar

  });

})(jQuery);


window.onload = function (){
  $('#opt-whatsapp').addClass('position').delay(2000).animate({ opacity: 1 }, 250);
}